import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=fed34aa2&scoped=true"
import script from "./Workspaces.vue?vue&type=script&lang=js"
export * from "./Workspaces.vue?vue&type=script&lang=js"
import style0 from "./Workspaces.vue?vue&type=style&index=0&id=fed34aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed34aa2",
  null
  
)

export default component.exports